import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslationModule } from '@galaxy/crm/static';

import { AutomationActionsService } from './row-actions/automation-actions.service';
export { AutomationActionsService };

const CRM_ROUTES: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(CRM_ROUTES), TranslationModule],
  exports: [RouterModule],
  providers: [AutomationActionsService],
})
export class CrmAutomationIntegrationsModule {}
